import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import CaspianXXQueryProcessingHistoryItem from '../../../Domain/CaspianXXQueryProcessingHistoryItem';
import CaspianXXQueryProcessingHistorySearchParams from './CaspianXXQueryProcessingHistorySearchParams';
import CaspianXXApiClientAndSurveyIdPairWindowDescription from '../CaspianXXApiClientAndSurveyIdPairAdmin/CaspianXXApiClientAndSurveyIdPairWindowDescription';
import CaspianXXQueryProcessingHistoryService from '../../../Services/CaspianXXQueryProcessingHistoryService';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import CaspianXxApiQueryItem from '../../../Domain/CaspianXxApiQueryItem';
import CaspianXXApiQueryService from '../../../Services/CaspianXXApiQueryService';
import CaspianXxApiQuerySearchParams from '../CaspianXxApiQueryAdmin/CaspianXxApiQuerySearchParams';
import CaspianXxApiQueryWindowDescription from '../CaspianXxApiQueryAdmin/CaspianXxApiQueryWindowDescription';
import CaspianXxApiClientAndSurveyIdPairItem from '../../../Domain/CaspianXxApiClientAndSurveyIdPairItem';
import CaspianXXApiClientAndSurveyIdPairService from '../../../Services/CaspianXXApiClientAndSurveyIdPairService';
import CaspianXXApiClientAndSurveyIdPairSearchParams from '../CaspianXXApiClientAndSurveyIdPairAdmin/CaspianXXApiClientAndSurveyIdPairSearchParams';
import TabbedPage from '../../../Elements/TabbedPage';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import CaspianXXApiClientAndSurveyIdPairMassEditWindowDescription from '../CaspianXXApiClientAndSurveyIdPairAdmin/CaspianXXApiClientAndSurveyIdPairMassEditWindowDescription';

export default class CaspianXXQueryProcessingHistoryAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      itemList: [],
      selected: -1,
      selectedItem: null,
      shownPanel: ShownPanelsEnum.None,
      searchItem: new CaspianXXQueryProcessingHistorySearchParams(),
      selectedTab: 0,
      allItemsInTheSearchSetAreSelected: false,
    };
    this.showPanel = this.showPanel.bind(this);
    this.tabChange = this.tabChange.bind(this);
    this.editPanelOnClose = this.editPanelOnClose.bind(this);
    this.changeOfItemListFunction = this.changeOfItemListFunction.bind(this);
    CaspianXxApiQueryItem.editFunction = this.clickOnQueryEditIcon.bind(this);
    CaspianXxApiClientAndSurveyIdPairItem.editFunction = this.clickOnEditClientSurveyPairIcon.bind(this);
  }

  clickOnQueryEditIcon(selectedId, selectedItem) {
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  clickOnEditClientSurveyPairIcon(selectedId, selectedItem) {
    this.setState({
      selected: selectedId,
      selectedItem,
      shownPanel: ShownPanelsEnum.EditMainItem,
    });
  }

  tabChange(newValue) {
    switch (newValue) {
      case 0: {
        this.setState({ searchItem: new CaspianXXQueryProcessingHistorySearchParams() });
        break;
      }
      case 1: {
        this.setState({ searchItem: new CaspianXxApiQuerySearchParams() });
        break;
      }
      case 2: {
        this.setState({ searchItem: new CaspianXXApiClientAndSurveyIdPairSearchParams() });
        break;
      }
      default:
        break;
    }
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  editPanelOnClose(refresh) {
    const tab = this.state.shownPanel === ShownPanelsEnum.AddNewItem ? 2 : this.state.selectedTab;

    this.setState({ shownPanel: ShownPanelsEnum.None });
    if (refresh) {
      this.setState({ selectedTab: -1, searchItem: { ...this.state.searchItem } }, () =>
        this.setState({ selectedTab: tab })
      );
    }
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={CaspianXxApiQueryWindowDescription}
            errorCode='CQPHA105'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new CaspianXxApiClientAndSurveyIdPairItem()}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={CaspianXXApiClientAndSurveyIdPairWindowDescription}
            errorCode='CQPHA113'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditMainItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={CaspianXXApiClientAndSurveyIdPairWindowDescription}
            errorCode='CQPHA122'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.MultiEdit,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={{
              IsActive: this.state.searchItem.IsActive,
              ChangeEndDate: false,
              EndDate: new Date(),
              ItemList: this.state.allItemsInTheSearchSetAreSelected ? [] : this.getSelectedPairIds(),
              SearchParams: this.state.searchItem,
            }}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={CaspianXXApiClientAndSurveyIdPairMassEditWindowDescription}
            errorCode='CQPHA135'
          />
        )}
      </div>
    );
  }

  getSelectedPairIds() {
    return Array.from(
      this.state.itemList.filter((item) => item.Selected),
      (x) => x.Id
    );
  }

  IsAnyItemSelected() {
    return this.state.itemList.find((u) => u.Selected === true) !== undefined;
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          colors={[ButtonColorsEnum.Primary, ButtonColorsEnum.Common]}
          tooltips={['New Client-Survey Pair', 'Multi Edit']}
          keys={[ShownPanelsEnum.AddNewItem, ShownPanelsEnum.MultiEdit]}
          icons={['fa-solid fa-plus-circle', 'fa-brands fa-grav']}
          roles={['User', 'Admin']}
          disabled={[null, !this.IsAnyItemSelected()]}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  changeOfItemListFunction(itemList) {
    this.setState({ itemList });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabbedPage
          tabs={[
            {
              label: 'Processing History',
              id: 'history',
              icon: 'fa-solid fa-monument',
              component: (
                <TabOfDataTable
                  type={CaspianXXQueryProcessingHistoryItem}
                  shownPanel={this.state.shownPanel}
                  serviceFunction={CaspianXXQueryProcessingHistoryService.GetListBySearching}
                  convertDBItemsFunction={CaspianXXQueryProcessingHistoryService.ConvertDBItems}
                  searchItem={this.state.searchItem}
                  searchParamsType={CaspianXXQueryProcessingHistorySearchParams}
                  showSearchStrip={true}
                  clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
                  key={'aprocessing history'}
                  errorCode='CQPHA178'
                  singleSearchLine={true}
                  singleSearchLinePlaceholder='Search in id, type or real query...'
                />
              ),
            },
            {
              label: 'API Queries',
              id: 'queries',
              icon: 'fa-solid fa-handshake',
              component: (
                <TabOfDataTable
                  type={CaspianXxApiQueryItem}
                  shownPanel={this.state.shownPanel}
                  serviceFunction={CaspianXXApiQueryService.GetListBySearching}
                  convertDBItemsFunction={CaspianXXApiQueryService.ConvertDBItems}
                  searchItem={this.state.searchItem}
                  key={'api queries'}
                  errorCode='CQPHA194'
                />
              ),
            },
            {
              label: 'Client-Survey Pairs',
              id: 'pairs',
              icon: 'fa-solid fa-hand-holding-hand',
              component: (
                <TabOfDataTable
                  type={CaspianXxApiClientAndSurveyIdPairItem}
                  shownPanel={this.state.shownPanel}
                  serviceFunction={CaspianXXApiClientAndSurveyIdPairService.GetListBySearching}
                  convertDBItemsFunction={CaspianXXApiClientAndSurveyIdPairService.ConvertDBItems}
                  searchItem={this.state.searchItem}
                  searchParamsType={CaspianXXApiClientAndSurveyIdPairSearchParams}
                  showSearchStrip={true}
                  changeOfItemListFunction={this.changeOfItemListFunction}
                  clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
                  changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) =>
                    this.setState({ allItemsInTheSearchSetAreSelected })
                  }
                  itemTypeName={'pairs'}
                  key={'client-survey pairs'}
                  errorCode='CQPHA216'
                  singleSearchLine={true}
                  singleSearchLinePlaceholder='Search in id, type or result...'
                />
              ),
            },
          ]}
          className='border rounded opacity70'
          onTabChange={this.tabChange}
        />
      </div>
    );
  }
}
